module.exports = __webpack_public_path__ + "media/icons/sprzedaz-ac8ff15c.png";